module.exports = __webpack_public_path__ + "static/media/14_3.6012b47d.jpg";